;(function () {
  'use strict';

  let angular = window.angular;

  Controller.$inject = ['$scope', 'UserService', 'LocalStorageService'];

  angular
    .module('app')
    .component('accountChangePassword', {
      template:'<form name="ctrl.changePasswordForm" class="validate" novalidate autocomplete="off"><div class="modal-header"><button type="button" class="close" ng-click="ctrl.modalInstance.dismiss()" ng-if="!ctrl.forced"><i class="fas fa-times"></i></button> <span translate>buttons.change</span> <span translate>entities._all.password</span></div><div class="modal-body paddingB0"><div class="alert alert-info" ng-if="ctrl.forced" translate>entities.user.password.mustChangePasswordInfo</div><div class="row"><div class="form-group" show-errors><label class="control-label" for="new-password" translate>entities.user.password.new</label> <input ng-model="ctrl.form.password" id="new-password" ng-change="ctrl.onChange()" ng-blur="ctrl.onBlur()" type="password" class="form-control" name="password" required ng-minlength="ctrl.minPassLength" translate-attr="::{placeholder: \'entities.user.password.new\'}"><div class="help-block" ng-messages="ctrl.changePasswordForm.password.$error"><div ng-messages-include="messages.html"></div></div></div><div class="form-group" show-errors><label class="control-label" for="repeat-password" translate>entities.user.password.confirmNew</label> <input ng-model="ctrl.form.repeatPassword" id="repeat-password" ng-change="ctrl.onChange()" ng-blur="ctrl.onBlur()" type="password" class="form-control" name="repeatPassword" required ng-minlength="ctrl.minPassLength" translate-attr="::{placeholder: \'entities.user.password.confirmNew\'}"><div class="help-block" ng-messages="ctrl.changePasswordForm.password.$error"><div ng-messages-include="messages.html"></div></div></div></div><div style="margin: 0 -15px; padding: 15px" class="body-bg"><div class="form-group marginB0" show-errors><label class="control-label" for="currentPass" translate>entities.user.password.current</label> <input id="currentPass" type="password" required name="currentPassword" autocomplete="new-password" translate-attr="::{placeholder: \'entities.user.password.current\'}" ng-model="ctrl.form.oldPassword" class="form-control"><div class="help-block" ng-messages="ctrl.changePasswordForm.password.$error"><div ng-messages-include="messages.html"></div></div></div></div></div><div class="alert alert-warning no-margin text-center" ng-show="ctrl.saveError">{{ctrl.saveError}}</div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" ng-if="!ctrl.forced" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-click="ctrl.changePassword()" translate>buttons.save</button></div></form><spinner css-class="\'small\'" show-logo="true" show="ctrl.saving"></spinner>',
      controller: Controller,
      controllerAs: 'ctrl',
      bindings: {
        modalInstance: '<',
        resolve: '<'
      }
    });

  function Controller ($scope, UserService, LocalStorageService) {
    let vm = this;

    vm.$onInit = function onInit () {
      vm.user = angular.copy(vm.resolve.user);
      vm.forced = !!vm.resolve.forced;
      vm.minPassLength = 6;
      vm.form = {};

      vm.changePassword = changePassword;
      vm.onChange = onChange;
      vm.onBlur = onBlur;
    };

    function changePassword () {
      let password = vm.form.password;
      let repeatPassword = vm.form.repeatPassword;

      if (password && repeatPassword && password !== repeatPassword) {
        vm.changePasswordForm.password.$setValidity('password_mismatch', false);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', false);
      }

      if (!vm.changePasswordForm.$valid) {
        $scope.$broadcast('show-errors-check-validity');
        return;
      }

      vm.saving = true;
      UserService
        .changePassword(vm.user, vm.form.oldPassword, vm.form.password)
        .then(response => {
          vm.saving = false;
          LocalStorageService.clear();
          vm.modalInstance.close(response);
        })
        .catch(err => {
          vm.saving = false;
          console.log(err);
          vm.saveError = err;
        });
    }

    function onChange () {
      let password = vm.form.password || '';
      let repeatPassword = vm.form.repeatPassword || '';
      if (password.length < vm.minPassLength && repeatPassword.length < vm.minPassLength) {
        vm.changePasswordForm.password.$setValidity('password_mismatch', true);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', true);
      }
    }

    function onBlur () {
      let password = vm.form.password || '';
      let repeatPassword = vm.form.repeatPassword || '';
      if (password && repeatPassword && password !== repeatPassword) {
        vm.changePasswordForm.password.$setValidity('password_mismatch', false);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', false);
      } else {
        vm.changePasswordForm.password.$setValidity('password_mismatch', true);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', true);
      }
    }

  }
})();
